import { useState, useEffect ,useCallback , useRef} from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import imageCompression from 'browser-image-compression';
import { toast } from "react-toastify";
import QRCode from 'qrcode.react';

import Multiselect from 'multiselect-react-dropdown';
import "react-data-table-component-extensions/dist/index.css";
import * as React from 'react';
import $ from 'jquery';
import TableToExcel from '@linways/table-to-excel';
import DataTable from 'react-data-table-component'; 
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as reportActions from "../../actions/reportActions";
import Loader from "../../components/Loader";
import LoanVersioning from './LoanVersioning';

import AccessDenied from '../common/AccessDenied';
import * as beatPlanActions from "../../actions/beatPlanActions";
import * as masterAction from "../../actions/masterAction";

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const InTrayOutTrayReport = (props) => {
    const theme = useTheme();
    const { id } = useParams();
    const { urlAgreementNo } = useParams();
    const { urlIdentifier } = useParams();    
    const { brief } = useParams();
     const location = useLocation();
    const { actions, usersData } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    
    const navigate = useNavigate();
 
    const [permissions, setPermissions] = useState([]);
    const [userRoleType, setUserRoleType] = useState('');
    const [loggeInUserID, setLoggeInUserID] = useState('');

    const [allTags, setAllTags] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [businessDoneLoans, setBusinessDoneLoans] = useState([]);
    const [loanDetailsEMIS, setLoanDetailsEMIS] = useState([]);
    const [backOfficeUsersArr, setBackOfficeUsersArr] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const [sendCrifOpenModal, setSendCrifOpenModal] = React.useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sendCrifFormData, setSendCrifFormData] = useState({ email_address: '' });
    const [preloaderStatus, setPreloaderStatus] = useState(false);

    const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);

    const [beatPlanLocation, setBeatPlanLocation] = useState([]);
    const [allCampaigns, setAllCampaigns] = useState([]);
    const [selectedVisitType, setSelectedVisitType] = useState([]);
    const [loanID, setLoanID] = useState('');
    const [loanDetailStatus, setLoanDetailStatus] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [versioningLoans, setVersioningLoans] = useState([]);
	const [businessDoneLoan, setBusinessDoneLoan] = useState([]);
    const [reportName, setReportName] = useState('');
    const [cronRunDateArr, setCronRunDateArr] = useState([]);
    const [cronRunTabsReloadStatus, setCronRunTabsReloadStatus] = useState(true);
    const [activeLoanTab, setActiveLoanTab] = useState(0);
    const [auditAllLoansButtonStatus, setAuditAllLoansButtonStatus] = useState(false);

    const [keyword, setKeyword] = useState('');
    const [isENACHRegistrationChecked, setIsENACHRegistrationChecked] = useState(false);
    const [selectedTag, setSelectedTag] = useState('');
    
    const [totalOutstandingAmt, setTotalOutstandingAmt] = useState(0);
    const[intentUrlRazorpay, setIntentUrlRazorpay] = useState('');
 
    const [formValues, setFormValues] = useState({
        amount: '',
        amountRazorpay:''
    });

    const [qrCodeAmount, setQrCodeAmount] = useState(0);
    const [qrCodeAmountRazorpay, setQrCodeAmountRazorpay] = useState(0);

    const [selectedDocumentFiles, setSelectedDocumentFiles] = useState([]);
    const [compressedFile, setCompressedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [isMobile , setIsMobile] = useState(null);

    const childRef = useRef();
    const fileInputRef = useRef();
    const cameraInputRef = useRef();

    const [previews, setPreviews] = useState([]);
    const [compressedFiles, setCompressedFiles] = useState([]);
    const [imageDetails, setImageDetails] = useState([]); 
    const [preloaderSubmitStatus, setPreloaderSubmitStatus] = useState(false);
    const [page, setPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const RECORDS_PER_PAGE = 100;
    const [activeListIdentifier, setActiveListIdentifier] = useState('intray');
    const [showListStatus, setShowListStatus] = useState(false);
    const [widgets, setWidgets] = React.useState({}); 
    const[selectedBoxName, setSelectedBoxName] = useState('');
    const[selectedSubCategory, setSelectedSubCategory] = useState('');
    const [expandedBoxes, setExpandedBoxes] = useState({});

    useEffect(() => {

         const apiData = {
            Bureau: { widget1: 10, widget2: 20 },
            Checklist: { widget1: 5, widget2: 15 },
            };
       //  setWidgets(apiData);

        if (brief !== undefined ) {
            setReportName(brief); 
        }
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        const roleName = localStorage.getItem('authUserRoleName'); 
        if (authToken === null) {
            navigate('/login');
        }

        if (id !== undefined ) {
            const idVal = atob(id);            
            setLoanID(idVal); 
             setLoanDetailStatus(true);
        } 

        if (urlIdentifier !== undefined ) {
         setActiveListIdentifier(urlIdentifier);
        }

        if (roleName !== undefined ) {
           setUserRoleType(roleName);
        } 

    }, [setLoanID,id,setReportName,setActiveListIdentifier,urlIdentifier,setUserRoleType,selectedBoxName,selectedSubCategory, keyword]); 
 

    const fetchRecords = useCallback(() => {
    if (userRoleType === '') return; 

    setBusinessDoneLoans([]);
    setWidgets([]);
    setBackOfficeUsersArr([]);
    setPreloaderStatus(true);
    setLoading(true);

    const offset = (page - 1) * RECORDS_PER_PAGE;

    console.log(
        `selectedBoxName = ${selectedBoxName}, selectedSubCategory = ${selectedSubCategory}, keyword = ${keyword}`
    );

    const params = {
        keyword,
        start: '0',
        length: config.MAX_RECORDS,
        brief: 'intray_outtray_report',
        page,
        limit: RECORDS_PER_PAGE,
        offset,
        activeListIdentifier,
        userRoleType,
        selectedBoxName,
        selectedSubCategory,
    };

    const requestData = encryptData(params);

    actions.getInTrayOutTrayData(requestData, false)
        .then((result) => {
            setLoading(false);
            setPreloaderStatus(false);

            if (result.data?.success === 1) {
                const results = result.data.data.all_records || {};
                const resultArr = Object.keys(results).map((key) => results[key]);

                setBusinessDoneLoans(resultArr);
                setBackOfficeUsersArr(result.data?.backOfficeUsers ?? []);
                setWidgets(result.data?.widgetsBoxes ?? []);
                setTotalRows(result.data?.total || 0);

                console.log("Fetched Records:", resultArr);
            } else {
                setTotalRows(0);
            }
        })
        .catch((error) => {
            setPreloaderStatus(false);
            setLoading(false);
            console.error("Error fetching lead list:", error);
        });
}, [
    selectedBoxName,
    selectedSubCategory,
    keyword,
    page,
    config.MAX_RECORDS,
    RECORDS_PER_PAGE,
    activeListIdentifier,
    userRoleType,
]);

// Trigger fetchRecords when dependencies change
useEffect(() => {
    fetchRecords();
}, [fetchRecords]);

// Handle submit manually
const onSubmit = (data) => {
    fetchRecords();
};

// Handle widget click (state change triggers useEffect)
const handleWidgetClick = (boxName, subCategory, count, widgetObj=[]) => {

   
    if(Object.prototype.hasOwnProperty.call(widgetObj, 'recordFor')){ 
        const firstKey =  widgetObj?.visit_type_id;
        window.open(`/dashboard/beat-plan/${firstKey}`, "_blank", "noopener,noreferrer");
    }else{
        setSelectedBoxName(boxName);
        setSelectedSubCategory(subCategory);
    }
    
};
 
    const colors = [
        "#e26a6a", // dark slate
        "#578ebe", // dark gray
        "#f3c200", // deep purple
        "#36d7b7", // navy blue
        "#8e44ad", // dark green
        "#67809f" 
        ];

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getUserModuleData(requestData);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {
                const permissionsData = result.data.data;
                setPermissions(permissionsData);
                const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Audit Report')?.view_permission;
                setPermissions(permissionsData);
                setViewModulePermissionStatus(hasViewPermissions);
                setUserHasPermission(hasViewPermissions);

                if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
                 //   setUserRoleType(result.data.user_info[0].role_type);
                    // alert(result.data.user_info[0].role_type);
                    setLoggeInUserID(result.data.user_info[0].user_id);
                }
            } 
        }).catch((error) => {
            // console.error("Promise rejected -  lead list:", error);
        });
    }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID]);
 
    const handleKeywordChange = (event) => {
        setKeyword(event.target.value); 
    };
    const handleENACHRegistrationChange = (event) => {
         setIsENACHRegistrationChecked(event.target.checked);
    };

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    useEffect(() => {
        setPreloaderStatus(true);

        const today = new Date();
        const todayFormatted = formatDate(today);

        setStartDate(todayFormatted);
        setEndDate(todayFormatted);

        setValue("start_date", todayFormatted);
        setValue("end_date", todayFormatted);

        // console.log("111111 - id = ",id);

        if (id !== undefined ) {
            setBusinessDoneLoans([]);
            setLoanDetailsEMIS([]);
            setVersioningLoans([]);
            const idVal = atob(id); 
            const agreementNo = atob(urlAgreementNo);  
            
            let reportName = '';
            if (brief !== undefined ) {
                reportName = brief; 
            }
            // alert(reportName);
            // alert(idVal);      
            setLoanID(idVal); 
             setLoanDetailStatus(true);
             setAuditAllLoansButtonStatus(true);
 
              setLoading(true);

            
             if (userRoleType === '') return;
            setBusinessDoneLoans([]);
            setLoanDetailsEMIS([]);
            setBusinessDoneLoan([]);

            setWidgets([]);    
            const offset = (page - 1) * RECORDS_PER_PAGE;
             const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted ,'loan_id' : idVal ,'reportName' : reportName, 'keyword' : keyword ,'activeListIdentifier' : activeListIdentifier , "userRoleType" :userRoleType };
                const requestData = encryptData(params);
                setBackOfficeUsersArr([]);
                const response = actions.getInTrayOutTrayData(requestData, false);
                response.then((result) => {
                    setLoading(false);
                    setPreloaderStatus(false);
                    // console.log("Promise resolved -  getInTrayOutTrayData:", result);
                    setTotalRows(result.data?.total || 5000);
                    if (result.data.success === 1) {
                        setPreloaderStatus(false);
                        const results = result.data.data.all_records;
                        const resultArr = Object.keys(results).map((key) => results[key]);
                        setVersioningLoans(resultArr);
                        setBusinessDoneLoans(resultArr);    
                        console.log("resultArr = ",resultArr);
                        setBackOfficeUsersArr(result.data?.backOfficeUsers ?? []); 
                        const defaultTabIndex = (resultArr.length >0) ? (resultArr.length - 1) : 0;
                        setActiveTab(defaultTabIndex);
                        setWidgets(result.data?.widgetsBoxes ?? []);
                            
                    }  

                }).catch((error) => {
                    setPreloaderStatus(false);
                    console.error("Promise rejected -  getInTrayOutTrayData:", error);
                });
        }else{ 
            if (userRoleType === '') return;
            setPreloaderStatus(false);
            setBusinessDoneLoans([]);
            setLoanDetailsEMIS([]);
            setBusinessDoneLoan([]);


            setLoading(true);
            const offset = (page - 1) * RECORDS_PER_PAGE;
            const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted, 'keyword' : keyword , "page" : page ,"limit": RECORDS_PER_PAGE,
            "offset" : offset ,'activeListIdentifier' : activeListIdentifier, "userRoleType" :userRoleType };
            const requestData = encryptData(params);
            setBackOfficeUsersArr([]);
            const response = actions.getInTrayOutTrayData(requestData, false);
            response.then((result) => {
                setLoading(false);
                // console.log("Promise resolved -  getInTrayOutTrayData:", result);
                setTotalRows(result.data?.total || 0);
                if (result.data.success === 1) {
                    setPreloaderStatus(false);
                    const results = result.data.data.all_records;
                    const resultArr = Object.keys(results).map((key) => results[key]);
                    console.log("resultArr 3 = ",resultArr);
                    setBusinessDoneLoans(resultArr);
                    setBackOfficeUsersArr(result.data?.backOfficeUsers ?? []);
                    setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);
                    setWidgets(result.data?.widgetsBoxes ?? []);
                }  
            }).catch((error) => {
                setPreloaderStatus(false);
                console.error("Promise rejected -  getInTrayOutTrayData:", error);
            });
        } 
        
    }, [setBusinessDoneLoans,setLoanID,setLoanDetailsEMIS,setLoanDetailStatus,id, setBusinessDoneLoan,setVersioningLoans, setCronRunDateArr, setTotalOutstandingAmt, totalOutstandingAmt,page ,setBackOfficeUsersArr]);
  
    

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setPage(newPage);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
        setPage(1);
    };

    const filteredItems = businessDoneLoans.filter(item => {
        const AgreementNo = item.AgreementNo?.toLowerCase() || '';
        const CustomerName = item.CustomerName?.toLowerCase() || '';
        return (
            AgreementNo.includes(searchQuery.toLowerCase()) ||
            CustomerName.includes(searchQuery.toLowerCase())            
        );
    });

    const startIndex = (currentPage - 1) * config.HUNDREAD_PER_PAGE;
    const endIndex = startIndex + config.HUNDREAD_PER_PAGE;
    const paginatedItems = filteredItems.slice();
    const totalPages = Math.ceil(filteredItems.length / config.HUNDREAD_PER_PAGE);
     
    const exportLoansReport = async () => {
        const table = document.getElementById('exportLoansReportExcelFile');
        
        // Debugging log: Check if table is correctly selected
        console.log('Table:', table);
        
        const headersRow = table.querySelector('thead tr');
        const headers = Array.from(headersRow.querySelectorAll('th'));
        const actionColumnIndex = headers.findIndex(th => th.innerText.trim() === 'Action');
        
        // Debugging logs: Check headersRow and actionColumnIndex
        console.log('Headers Row:', headersRow);
        console.log('Action Column Index:', actionColumnIndex);
        
        if (actionColumnIndex !== -1) {
            // Debugging log: Check the header element to remove
            console.log('Header to Remove:', headers[actionColumnIndex]);
            
            headersRow.removeChild(headers[actionColumnIndex]);
        } else {
            console.log('Action column not found.');
        }
    
        TableToExcel.convert(table, {
            name: 'IntrayOutTray.xlsx',
            sheet: {
                name: 'Audit-Report',
            },
        });
    
        // Re-append the action column header if it was removed
        if (actionColumnIndex !== -1) {
            headersRow.appendChild(headers[actionColumnIndex]);
        }
    };
 
    useEffect(() => {
        if (cronRunDateArr.length > 0) {
            setActiveLoanTab(cronRunDateArr.length - 1);
        }
    }, [cronRunDateArr, setActiveLoanTab]);

    const goBackBtn = (event) => {
        setLoanDetailStatus(false);
        setAuditAllLoansButtonStatus(false);
        const url = `/dashboard/allcloud-loans-report`;
       // window.open(url, '_self');
        navigate(url);
      };
    const selectRefSL = useRef(null);  

    const handleUserChange = (e,leadId) => {  
            if (leadId !== "") {
                  const obj = {
                    start: "0",
                    length: config.MAX_RECORDS,
                    backOfficeUser: e.target.value,
                    lead_id: leadId,
                    "userRoleType" : userRoleType
                  };
                  const requestData = encryptData(obj);            
                  const response = actions.assignLeadToBackOfficeUser(requestData);
                  response
                    .then((result) => {                          
                       if (result.data.success === 1) {
                            toast.success(result.data.data.message, {
                              position: "top-right",
                            });
                            onSubmit();// reload list
                      }
                    })
                    .catch((error) => {
                     toast.error(error, {
                                 position: "top-right",
                               });
                    });
                }  
    }
  
   
      const moneyFormatIndia = (number) => {
        if (number !== undefined && number !== null && !Number.isNaN(Number(number))) {
            number = parseFloat(number).toFixed(2);  // Ensure two decimal places
    
            const [integerPart, decimalPart] = number.split('.');
    
            const lastThreeDigits = integerPart.slice(-3);
            const otherDigits = integerPart.slice(0, -3);
    
            let formattedIntegerPart;
            if (otherDigits !== '') {
                formattedIntegerPart = `${otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${lastThreeDigits}`;
            } else {
                formattedIntegerPart = lastThreeDigits;
            }
    
            return `${formattedIntegerPart}.${decimalPart}`;
        }
    
        return '0.00';  // Default return value for invalid inputs
    };
    
    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
    
        return `${day}-${month}-${year}`;
    };

    const columns = [
       
         {
            name: 'Date',
            selector: row => row.created_date,
            sortable: true,
        },
        {
        name: 'Lead Details',
        selector: row => row.mobile,
        sortable: false,
        cell: row => (
            <div>
            Mobile : <a
                href={`/dashboard/edit-lead/${btoa(row.id)}`}
                style={{ textDecoration: 'none', color: 'blue' }}
                target="_blank"
                rel="noopener noreferrer"
            >
                {row.mobile}
            </a>
            <div style={{ fontSize: '12px', color: '#555' }}>
                 Name: {row.name}
            </div>
            </div>
        ),
        },
        
       
       {
        name: 'Assigned to',
        selector: row => (
            <>
            <div>{row.leadAssigned}</div>
            {row.backOfficeUserNames && (
                <div style={{ fontSize: '12px', color: '#666' }}>
                Back Office User - {row.backOfficeUserNames}
                </div> 
            )}
            </>
        ),
        sortable: true,
        },
        {
        name: 'Status',
        selector: row => (
            <>
            <div>{row.userAction}</div>
            {backOfficeUsersArr?.length > 0 && userRoleType !== 'User' && (
                <div style={{ fontSize: '12px', color: '#666' }}>
                <select
                    id={`back_office_user_id_${row.id}`}
                    name="back_office_user_id"
                    className="form-select"
                    value={row.backOfficeUser || ""}
                    onChange={(event) => handleUserChange(event, row.id)}
                    ref={selectRefSL}
                >
                    <option value="">Assign to User</option>
                    {backOfficeUsersArr.map((option) => (
                    <option key={option.user_id} value={option.user_id}>
                        {option.name}
                    </option>
                    ))}
                </select>
                </div>
            )}
            </>
        ),
        sortable: true,
        },
        { 
        name: 'Action',
        sortable: true,
        cell: row => (
            <Tooltip title={row.actionableName} enterTouchDelay={0}>
            <span
                style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: 'inline-block',
                maxWidth: '200px'
                }}
            >
                {row.actionableName}
            </span>
            </Tooltip>
        ),
        }
        
        
    ];

    // Conditional row styles to change text color
        const conditionalRowStyles = [
            {
            when: row => row.AgreementNo === 'Success',   
            style: {
                color: 'green',
            },
            },
            {
            when: row => row.AgreementNo === 'Aborted',  
            style: {
                color: 'red',
            },
            },
            {
            when: row => row.AgreementNo === 'Failed',  
            style: {
                color: 'red',
            },
            },
        ];

    

    function isMobileDevice() {
     return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

     const handleImageChange = async (event) => {
    setPreloaderStatus(true);
    const file = event.target.files[0];
    if (!file) return;

    const options = {
        maxSizeMB: 1,
        useWebWorker: true,
        maxWidthOrHeight: undefined,
    };

    try {
        const compressedFile = await imageCompression(file, options);

        const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(compressedFile);
        });

        const imageData = {
        name: file.name,
        originalSize: (file.size / 1024).toFixed(2),
        compressedSize: (compressedFile.size / 1024).toFixed(2),
        previewUrl: URL.createObjectURL(compressedFile),
        base64: base64Data,
        };

        setPreviews([imageData.previewUrl]);
        setCompressedFiles([compressedFile]);
        setSelectedDocumentFiles([{ file: imageData.base64, name: imageData.name }]);
        setImageDetails([imageData]);
        setPreloaderStatus(false);
    } catch (error) {
        console.error("Image processing failed:", error);
        setPreloaderStatus(false);
    }
    };
    
        const handleDelete = (index) => {
            // Revoke preview URL
            setImageDetails(prevDetails => {
                const target = prevDetails[index];
                if (target?.previewUrl) {
                URL.revokeObjectURL(target.previewUrl);
                }
    
                const newDetails = prevDetails.filter((_, idx) => idx !== index);
    
                // Sync other states based on new imageDetails
                setPreviews(newDetails.map(img => img.previewUrl));
                setCompressedFiles(prev => prev.filter((_, idx) => idx !== index));
                setSelectedDocumentFiles(newDetails.map(img => ({
                file: img.base64,
                name: img.name
                })));
    
                return newDetails;
            });
            };
    
    const handleDocumentFileChange = (e) => {
    const file = e.target.files[0]; // Only take the first file
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (event) => {
        const base64Data = event.target.result;
        const fileName = file.name;
        setSelectedDocumentFiles([{ file: base64Data, name: fileName }]);
    };
    reader.readAsDataURL(file);
};

    const [openPaymentModal, setOpenPaymentModal] = React.useState(false);
    const btnOpenPaymentModal = () => setOpenPaymentModal(true);
    const handlePaymentModalClose = () => {
        setOpenPaymentModal(false);
        setSelectedDocumentFiles([]);  
    };

    const handleCallChild = () => {
       const tab = document.getElementById('pills-payment_documents-tab');
       if (tab) {
         tab.click();
        } 
    };
 
    const handlePaymentFormSubmit = (data) => {
        
        if (!selectedDocumentFiles || selectedDocumentFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else {
            const params = {"upload_file": selectedDocumentFiles , "AgreementNo" : businessDoneLoan.AgreementNo};
             setPreloaderStatus(true);
            const requestData = encryptData(params);
            const response = actions.uploadLoanPaymentData(requestData, navigate);

            response.then((result) => {
                 if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    reset();
                    setOpenPaymentModal(false);
                    setSelectedDocumentFiles([]);
                    setImageDetails([]);
                    handleCallChild();  
                   
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const [open, setOpen] = React.useState(false);
    const btnOpenUploadMissingData = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setSelectedItrFiles([]); // Reset selected ITR files
    };
    const [selectedItrFiles, setSelectedItrFiles] = useState([]);

    const handleItrFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedItrFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    

    const handleFormSubmit = (data) => {

        if (!selectedItrFiles || selectedItrFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else {

            const params = {"upload_file": selectedItrFiles };

            // setPreloaderStatus(true);
            const requestData = encryptData(params);
            const response = actions.uploadMissingData(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - uploadLeads form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    reset();
                    setOpen(false);
                    setSelectedItrFiles([]);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    }; 
    
    const { importName } = useParams();
    const [pageHeading , setPageHeading]  = useState('');
    const [iframeSrc , setIframeSrc]  = useState('');
    const [iframeLoaded, setIframeLoaded] = useState(false);

    useEffect(() => {
        const authToken = localStorage.getItem('authToken');
        let appUrl = config.APP_URL;
        appUrl = appUrl.replace('/public/', '/'); 
            setPageHeading('Loans Tagging');
            setIframeSrc(`${appUrl}excel_report/excel_import_loans_tagging.php?referrer=${btoa('lms_page')}&authToken=${authToken}`);        
        setIframeLoaded(true);
    }, [importName, setIframeLoaded]);

    const handleIframeLoad = () => {
        setIframeLoaded(true);
    }; 
     
    const [showHideTagStatus, setShowHideTagStatus] = useState(false);
    const handleToggle = () =>{
         setShowHideTagStatus(prevState => !prevState);  
    }
 
 
    if (!userHasPermission) {
        // Redirect or render an access denied message
      //  return <AccessDenied />;
    }


    useEffect(() => {
            if (urlIdentifier !== null) {
                console.log('ready to update list');
                onSubmit();
            }
    }, [activeListIdentifier,userRoleType,urlIdentifier]);

    const listDisplayHandler = (listIdentifier) => {
        setActiveListIdentifier(listIdentifier);
    } 

     // Toggle a specific box open/closed
    const toggleBox = (boxName) => {
        setExpandedBoxes((prev) => ({
        ...prev,
        [boxName]: !prev[boxName], // toggle current state
        }));
    };
    
    return (
        <>  
            <Helmet>
                <title>In-tray / Out tray | Ckers</title>
            </Helmet>
            <Container>  
                  <div style={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
                    {Object.entries(widgets).map(([boxName, widgetObj], index) => {
        const isExpanded = expandedBoxes[boxName] || false;

        return (
          <div
            key={boxName}
            style={{
              border: "1px solid #ccc",
              borderRadius: "6px",
              padding: "10px",
              background: colors[index % colors.length],
              width: "260px",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
            }}
          >
            {/* Header (click to expand/collapse) */}
            <button
  onClick={() => toggleBox(boxName)}
  style={{
    background: "none",
    border: "none",
    color: "#fff",
    cursor: "pointer",
    textAlign: "left",
    width: "100%",
    fontSize: "1rem",
    fontWeight: "bold",
    marginBottom: "10px",
  }}
>
             {isExpanded ? "▲" : "▼"} {boxName}
              <span
                style={{
                  color: "#ffffff",
                  fontSize: "13px",
                  float: "right",
                  background: "#007bff",
                  padding: "5px 10px",
                  borderRadius: "5px",
                }}
              >
                {widgetObj?.Total_counts || 0}
              </span>
            </button>
 

            {/* Expandable Section */}
            {isExpanded && (
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  transition: "all 0.3s ease",
                }}
              >
                {Object.entries(widgetObj)
                  .filter(([key]) => key !== "Total_counts" && key !== "recordFor" && key !== "loggedInUser" && key !== "visit_type_id") // skip total key
                  .map(([subCategory, count]) => (
                    <li
                      key={subCategory}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "4px",
                      }}
                    >
 

                      <button
                        onClick={() =>
                          handleWidgetClick(boxName, subCategory, count, widgetObj)
                        }
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          textAlign: "left",
                          padding: "0",
                        }}
                        type="button"
                      >
                        <span
                          style={{
                            color: "#fff",
                            fontWeight: "normal",
                          }}
                        >
                          {subCategory}
                        </span>
                        <span
                          style={{
                            fontSize: "13px",
                          }}
                        >
                          {count}
                        </span>
                      </button>
                    </li>
                  ))}
              </ul>
            )}
          </div>
        );
      })}
                    </div> 
               
                { selectedBoxName !=='' && (
                <> 
                <div id='main-wrap'  className={loanDetailStatus ? "d-none mb-3 mmt-7 filter mt-4" : "mb-3 mmt-7 filter mt-4"}>  
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='row mx-0'>

                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="keyword">
                                        <span>Keyword</span>
                                        <input type='text' name='keyword' id='keyword' className='form-control'{...register('keyword')} placeholder="Enter your value here..." onChange={handleKeywordChange}/>
                                    </label>
                                </div>
                            </div>
 

                            <div className='col'>
                                <div className='form-group mb-2'>
                                    <span className='d-block'>&nbsp;</span>
                                    <button className='btn btn-primary'>Search</button>
                                </div>
                            </div>
  
                        </div>
                    </form>
                </div>

                <div>
                  
                        {(showHideTagStatus) && (<div className='table-wrap'>
                            {!iframeLoaded && <div><div className='p-spinner'><div className="spinner">&nbsp;</div></div></div>}
                            <iframe
                                title="Report"
                                width="100%"
                                height="130"
                                src={iframeSrc}
                                frameBorder="0"
                                allowFullScreen
                                onLoad={handleIframeLoad}
                                style={{ display: iframeLoaded ? 'block' : 'none' }}
                            />
                        </div>
                        )
                        }
                        </div> 

                <div id="main-wrap">
                    <div className="row justify-content-between mt-4">
                        <div className="col-md-7">
                            <Typography className="line-initial" variant="h4" sx={{ mb: 0 }}>
                              { urlIdentifier === 'intray' ? "In-tray" : "Out-tray" } 
                            </Typography> 
                        </div>
                        <div className='col-md-5 text-end ps-lg-5'>                            
                        {(!loanDetailStatus) && (
                            <>
                            <div className="form-group d-flex justify-content-end align-items-center">
                                <label htmlFor="search" className='w-100 d-none'>
                                    {/* Search : */}
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        id="search"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </label>
                                <button className="btn btn-info text-white ms-3 d-none" onClick={() => exportLoansReport()}>
                                    Export
                                </button>                                
                            </div>
                            <div className="float-left mb-2"><b>Total Records : {totalRows}</b></div>
                            </>
                        )}                      
                        </div>
                    </div>

                    
                    <div className= "d-none">
                        <button className={ activeListIdentifier === 'intray' ? "btn btn-success text-white" : "btn btn-default text-white"} onClick={() => listDisplayHandler('intray')}>Intray</button>&nbsp;
                        
                        <button className={ activeListIdentifier === 'outtray' ? "btn btn-success text-white" : "btn btn-default text-white"} onClick={() => listDisplayHandler('outtray')}>Outtray</button>

                    </div>  

                        <DataTable
                            // title="My DataTable with Expandable Rows"
                            columns={columns}
                            data={businessDoneLoans}
                            progressPending={loading}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            paginationPerPage={RECORDS_PER_PAGE}
                            onChangePage={handlePageChange}
                            conditionalRowStyles={conditionalRowStyles}
                            // pagination
                        />
                </div>
               
                </>
                    )
                }
                 {preloaderStatus && <Loader />}
            </Container> 
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Upload Additional Data</h4>
                        <Button onClick={handleClose} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>File Upload <a style={{ color: "red" }}>*</a></span>
                                                <input
                                                    type='file'
                                                    id='itr_file'
                                                    name='itr_file'
                                                    className='form-control'
                                                    {...register('itr_file')}
                                                    onChange={handleItrFileChange}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>

        

        </>
    );
}

function mapStateToProps(state) {
    return {
        getInTrayOutTrayData: state.getInTrayOutTrayData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(reportActions.default, userActions.default, beatPlanActions.default, masterAction.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(InTrayOutTrayReport);   